

































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RenderPostModel } from "@/services/render/types";
import { Style } from "@/services/styles/types";
import { RecurenceEnum } from "@/services/posts/types";
import moment from "moment";
import {
    MeetingListPostProperties,
    MeetingListPostCSS,
    Meeting
} from "@/services/posts/postTypes/meetingList";
import { setNextItem } from "../types";

@Component
export default class MeetingListRender extends Vue {
    @Prop() private item!: RenderPostModel;
    @Prop() private active!: boolean;
    @Prop() private itemStyle!: Style;
    @Prop() private dateTime!: Date;

    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: boolean) {
        if (value) {
            return setTimeout(
                this.setNextItem,
                this.propertiesModel.showTime * 1000
            );
        }
    }

    get propertiesModel(): MeetingListPostProperties {
        const properties = this.item.properties
            ? (this.item.properties as MeetingListPostProperties)
            : ({} as MeetingListPostProperties);

        if (Object.entries(properties.meetings).length > 0) {
            if (this.dateTime !== null) {
                this.applyMeetingsScheduling(properties);
            }
        }
        return properties;
    }

    get styleModel(): MeetingListPostCSS {
        return this.item.css && Object.entries(this.item.css).length > 0 && this.item.css.constructor === Object ? this.item.css as MeetingListPostCSS : this.itemStyle ? this.itemStyle.css as MeetingListPostCSS : {} as MeetingListPostCSS;
    }

    applyMeetingsScheduling(content: MeetingListPostProperties) {
        const that = this;
        const filteredMeetingsList: Array<Meeting> = content.meetings.filter(function (meeting) {
            let viewStartDate: moment.Moment = moment(that.dateTime.valueOf());
            if (that.propertiesModel.skipDays && that.propertiesModel.skipDays > 0) {
                viewStartDate = moment(viewStartDate).add("days", Number(that.propertiesModel.skipDays));
            }
            let viewEndDate: moment.Moment = moment(viewStartDate.valueOf());
            if (that.propertiesModel.showDays && that.propertiesModel.showDays > 1) {
                viewEndDate = moment(viewEndDate).add("days", Number(that.propertiesModel.showDays - 1));
            }

            const fromDate: moment.Moment = moment(meeting.scheduling.fromDate);
            let toDate: moment.Moment = moment(meeting.scheduling.toDate);

            if (!meeting.scheduling.toDate && !meeting.scheduling.neverending) {
                toDate = moment(fromDate);
            }
            if (meeting.scheduling.neverending) {
                toDate = moment("9999-12-31");
            }

            const validMeeting: boolean =
                fromDate.isSameOrBefore(viewEndDate, "day") &&
                (meeting.scheduling.neverending ? true : toDate.isSameOrAfter(viewStartDate, "day")) &&
                (meeting.scheduling.allDay ? true : that.checkMeetingTime(meeting, viewStartDate)) &&
                (meeting.scheduling.recurenceType === RecurenceEnum.daily ? true
                    : meeting.scheduling.recurenceType === RecurenceEnum.weekly
                        ? that.checkRecurence(meeting, viewStartDate)
                        : meeting.scheduling.recurenceType === RecurenceEnum.monthly
                            ? that.checkRecurence(meeting, viewStartDate)
                            : meeting.scheduling.recurenceType === RecurenceEnum.yearly
                                ? that.checkRecurence(meeting, viewStartDate) : false
                );

            return validMeeting;
        });

        if (that.propertiesModel.maximumMeetings > 0) {
            const that: any = this;
            content.renderMeetings = filteredMeetingsList
                .sort(function (a, b) { return that.sortByScheduling(a, b); })
                .slice(0, that.settingsModel.maximumMeetings);
        } else {
            content.renderMeetings = filteredMeetingsList;
        }
    }

    sortByScheduling(a: Meeting, b: Meeting) {
        // asc sort by date and time
        if (new Date(a.scheduling.fromDate).getTime() > new Date(b.scheduling.fromDate).getTime()) {
            return 1;
        } else if (new Date(a.scheduling.fromDate).getTime() < new Date(b.scheduling.fromDate).getTime()) {
            return -1;
        }

        const aFromTime = moment(a.scheduling.fromDate)
            .set("hour", moment(a.scheduling.fromTime).get("hour"))
            .set("minute", moment(a.scheduling.fromTime).get("minute"));
        const bFromTime = moment(b.scheduling.fromDate)
            .set("hour", moment(b.scheduling.fromTime).get("hour"))
            .set("minute", moment(b.scheduling.fromTime).get("minute"));
        if (aFromTime > bFromTime) {
            return 1;
        } else if (aFromTime < bFromTime) {
            return -1;
        } else {
            return 0;
        }
    }

    checkRecurence(meeting: Meeting, viewStartDate: moment.Moment): boolean {
        let tempDate: moment.Moment = moment(viewStartDate.valueOf());
        for (let index = 0; index < this.propertiesModel.showDays; index++) {
            if (meeting.scheduling.recurenceType === RecurenceEnum.monthly &&
                meeting.scheduling.recurenceValues.includes(tempDate.date())) {
                return true;
            } else if (meeting.scheduling.recurenceType === RecurenceEnum.weekly &&
                meeting.scheduling.recurenceValues.includes(tempDate.day())) {
                return true;
            } else if (meeting.scheduling.recurenceType === RecurenceEnum.yearly &&
                moment(meeting.scheduling.yearly).dayOfYear() === moment(tempDate).dayOfYear()) {
                return true;
            }
            tempDate = tempDate.add("days", 1);
        }
        return false;
    }

    checkMeetingTime(meeting: Meeting, viewStartDate: moment.Moment): boolean {
        let valid: boolean = false;
        const fromTime: moment.Moment = moment(meeting.scheduling.fromTime);
        const toTime: moment.Moment = moment(meeting.scheduling.toTime);

        const tempFromTime = moment(viewStartDate).startOf("day");
        tempFromTime.set("hour", fromTime.hour()).set("minute", fromTime.minute());

        const tempToTime = moment(viewStartDate).startOf("day");
        tempToTime.set("hour", toTime.hour()).set("minute", toTime.minute());

        if (this.propertiesModel.removeMeetings === "Started") {
            valid = moment(tempFromTime).isAfter(viewStartDate);
        } else if (this.propertiesModel.removeMeetings === "Finished") {
            valid = moment(tempToTime).isAfter(viewStartDate);
        } else {
            valid = true;
        }
        return valid;
    }

    setNextItem() {
        this.$emit("setNextItem", { id: this.item.id } as setNextItem);
    }
}
